import { ICustomerAccountToPay } from '../../services/hpf-transaction-service';

export class SinglePaymentReceiptRouteSettings {
	accountPayments: ICustomerAccountToPay[];
	paymentInformation: any;
}
